import { FC, ReactElement } from "react";
import { Button, ButtonProps } from "@mui/material";
import { tokens } from "@/tokens";

interface IContainedButton extends ButtonProps {
  title: string;
}

const ContainedButton: FC<IContainedButton> = ({
  title,
  variant,
  size,
  ...rest
}): ReactElement => {
  return (
    <Button
      {...rest}
      variant={variant ?? "contained"}
      fullWidth
      sx={{
        fontSize: size === "large" ? tokens.fontSize.xl : tokens.fontSize.lg,
        fontWeight: size === "large" ? tokens.fontWeight.semibold : tokens.fontWeight.normal,
        boxShadow:
          variant === "text" || variant === "outlined"
            ? "none"
            : "0px 3px 8px 0px #1A1A1A26",
        border: variant === "text" ? `1px solid ${tokens.border.default}` : "",
        ...rest.sx,
      }}
    >
      {title}
    </Button>
  );
};

export default ContainedButton;
